import React from 'react';
import MerchantSignUp from 'containers/MerchantSignUp';

const MerchantSignUpPage = () => <MerchantSignUp />;

export default MerchantSignUpPage;
